import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IOption } from '../../entities';
import { PatientFormValues } from '../../entities/Form';
import InputField from '../InputField';
import RadioButtons from '../RadioButtons';
import Textarea from '../Textarea';
import styles from './PatientForm.module.scss';

interface PatientFormProps {
  errors: PatientFormValues;
  formValues: PatientFormValues;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | IOption) => void;
}

const PatientForm: FC<PatientFormProps> = ({ errors, formValues, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{t('patientInfo')}</div>
        <div className={styles.rows}>
          <div className={styles.row}>
            <InputField
              name="lastName"
              value={formValues.lastName}
              error={errors.lastName}
              onChange={onChange}
              title={t('surname')}
              placeholder={t('surname')}
            />
            <InputField
              name="firstName"
              value={formValues.firstName}
              error={errors.firstName}
              onChange={onChange}
              title={t('firstName')}
              placeholder={t('firstName')}
            />
          </div>
          <div className={styles.row}>
            <InputField
              name="idNo"
              value={formValues.idNo}
              error={errors.idNo}
              onChange={onChange}
              title={t('optionalHkId')}
              placeholder={t('exampleId')}
              reminders={[t('infoPurposeOnly')]}
            />
          </div>

          <div className={styles.row}>
            <InputField
              type="tel"
              name="mobileNo"
              value={formValues.mobileNo}
              error={errors.mobileNo}
              onChange={onChange}
              title={t("mobileNumber")}
              placeholder={`${t("mobileNumber")} (852)`}
              reminders={[
                `${t("verifyNumber")} (${t(
                  "onlyHongKongPhoneNumbersAreSupported"
                )})`,
              ]}
              dropdownOptions={[
                { name: "+852", value: "852" },
                // { name: '+853', value: '853' },
                // { name: '+86', value: '86' },
              ]}
              dropdownValue={
                [
                  { name: "+852", value: "852" },
                  // { name: '+853', value: '853' },
                  // { name: '+86', value: '86' },
                ].find((opt) => opt.value === formValues.countryCode)?.value
              }
              onChangeDropdownValue={(value) => onChange({ name: 'countryCode', value })}
              dropdownReadOnly
            />
            <InputField
              name="email"
              value={formValues.email}
              error={errors.email}
              onChange={onChange}
              title={t('optionalEmail')}
              placeholder={t('optionalEmail')}
            />
          </div>

          {/* <div className={styles.row}> */}
          <RadioButtons
            name="isJoinedEhealth"
            value={formValues.isJoinedEhealth}
            error={errors.isJoinedEhealth}
            onChange={onChange}
            title={t('activatedEHealth')}
            options={[
              { name: t('yes'), value: 'Y' },
              { name: t('no'), value: 'N' },
            ]}
            reminders={[t('eHealthReminder'), t('eHealthReminder2')]}
          />
          {/* </div> */}
        </div>
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{t('additionalInfo')}</div>
        <div className={styles.row}>
          <Textarea
            name="remarks"
            value={formValues.remarks}
            onChange={onChange}
            title={t('remarksOptional')}
            placeholder={t('remarksOptional')}
          />
        </div>
      </div>
    </div>
  );
};

export default PatientForm;
